import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=2a426eb2&scoped=true&"
import script from "./ShippingInfo.vue?vue&type=script&lang=ts&"
export * from "./ShippingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingInfo.vue?vue&type=style&index=0&id=2a426eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a426eb2",
  null
  
)

export default component.exports